const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchInventarioClientes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario de clientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioClientes:', error);
    throw error;
  }
};

export const fetchInventarioClientesByCliente = async (clienteId) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/cliente/${clienteId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario del cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioClientesByCliente:', error);
    throw error;
  }
};

export const createInventarioCliente = async (data) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al crear inventario de cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createInventarioCliente:', error);
    throw error;
  }
};

export const updateInventarioCliente = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar inventario de cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateInventarioCliente:', error);
    throw error;
  }
};

export const deleteInventarioCliente = async (id) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar inventario de cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deleteInventarioCliente:', error);
    throw error;
  }
};

export const ajustarStockCliente = async (id, cantidad, tipo) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/ajustar-stock/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cantidad, tipo }),
    });

    if (!response.ok) {
      throw new Error('Error al ajustar stock de cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en ajustarStockCliente:', error);
    throw error;
  }
};

export const recalcularInventarioCliente = async (clienteId) => {
  try {
    const response = await fetch(`${API_URL}/entregas-clientes/recalcular/${clienteId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error('Error al recalcular el inventario del cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en recalcularInventarioCliente:', error);
    throw error;
  }
};

export const fetchInventarioPorConductor = async (lavanderiaId, clienteIds) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/por-conductor`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lavanderiaId, clienteIds }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario del conductor');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioPorConductor:', error);
    throw error;
  }
};

export const fetchTotalesPorClientes = async (clienteIds) => {
  try {
    const response = await fetch(`${API_URL}/inventario-clientes/totales-por-clientes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ clienteIds }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener totales por clientes');
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('Error en fetchTotalesPorClientes:', error);
    throw error;
  }
};
